export const encounterScanSchema = {
    type: 'object',
    properties: {
        enctrNo: { type: 'string', nullable: true },
        patMrn: { type: 'string', nullable: true },
        patLastNm: { type: 'string', nullable: true },
        patFrstNm: { type: 'string', nullable: true },
        patMidNm: { type: 'string', nullable: true },
        patSsn: { type: 'string', nullable: true },
        patDob: { type: 'string', nullable: true },
        patZipCd: { type: 'string', nullable: true },
        admitDt: { type: 'string', nullable: true, description: 'Admission date only, no time' },
        admitTm: { type: 'string', nullable: true, description: 'Admission time only, no date' },
        dischDt: { type: 'string', nullable: true, description: 'Discharge date only, no time' },
        dischTm: { type: 'string', nullable: true, description: 'Discharge time only, no date' },
        purgedInd: { type: 'boolean', nullable: true },
        purgedDttm: { type: 'string', nullable: true },
        patAddrLn1: { type: 'string', nullable: true },
        patAddrLn2: { type: 'string', nullable: true },
        patCity: { type: 'string', nullable: true },
        patStateCd: { type: 'string', nullable: true },
        patCntryCd: { type: 'string', nullable: true },
        patPhNoHome: { type: 'string', nullable: true, description: 'Home phone number' },
        patPhNoBus: { type: 'string', nullable: true, description: 'Business/work phone number' },
        patPhNoMob: { type: 'string', nullable: true, description: 'Mobile phone number' },
        patEmailHome: { type: 'string', nullable: true, description: 'Home email address' },
        patEmailBus: { type: 'string', nullable: true, description: 'Business/work email address' },
        patDrLicNo: { type: 'string', nullable: true, description: "Driver's license number" },
        patDrLicSt: { type: 'string', nullable: true, description: "Driver's license state" },
        patDrLicExp: { type: 'string', nullable: true, description: "Driver's license expiration date" },
        patOccup: { type: 'string', nullable: true, description: "Patient's occupation" },
        patPrimLang: { type: 'string', nullable: true, description: "Patient's primary language" },
        patMaritalStatus: { type: 'string', nullable: true },
        patReligion: { type: 'string', nullable: true },
        patGenderCd: { type: 'string', nullable: true },
        patRace: { type: 'string', nullable: true },
        patEthnicGrp: { type: 'string', nullable: true },
        patNationality: { type: 'string', nullable: true },
        patDeceasedInd: { type: 'boolean', nullable: true },
        patDeceasedDt: { type: 'string', nullable: true },
        enctrAdmitTyp: { type: 'string', nullable: true },
        enctrPatClass: { type: 'string', nullable: true },
        enctrPatTyp: { type: 'string', nullable: true },
        enctrHospSvcCd: { type: 'string', nullable: true },
        accDt: { type: 'string', nullable: true },
        accCd: { type: 'string', nullable: true },
        accDesc: { type: 'string', nullable: true },
        accLocn: { type: 'string', nullable: true },
        accAutoStCd: { type: 'string', nullable: true },
        accAutoStNm: { type: 'string', nullable: true },
        accJobRelInd: { type: 'string', nullable: true },
        accDeathInd: { type: 'string', nullable: true },
        enctrInsuranceDoc: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: { type: 'string' },
                    insurancePlanId: { type: 'string', nullable: true },
                    insurerId: { type: 'string', nullable: true },
                    insurerName: { type: 'string', nullable: true },
                    insurerAddress1: { type: 'string', nullable: true },
                    insurerAddress2: { type: 'string', nullable: true },
                    insurerCity: { type: 'string', nullable: true },
                    insurerPostalCode: { type: 'string', nullable: true },
                    insurerStateAbbrev: { type: 'string', nullable: true },
                    insurerContactPerson: { type: 'string', nullable: true },
                    insurerPhone: { type: 'string', nullable: true },
                    insuredId: { type: 'string', nullable: true, description: 'The ID of the insured' },
                    insuredGroupEmplId: { type: 'string', nullable: true },
                    insuredGroupEmplName: { type: 'string', nullable: true },
                    insuredFirstName: { type: 'string', nullable: true },
                    insuredLastName: { type: 'string', nullable: true },
                    insuredMiddleName: { type: 'string', nullable: true },
                    insuredSuffix: { type: 'string', nullable: true },
                    insuredRelToPatient: { type: 'string', nullable: true },
                    insuredDOB: { type: 'string', nullable: true },
                    insuredSSN: { type: 'string', nullable: true },
                    insuredAddress1: { type: 'string', nullable: true },
                    insuredAddress2: { type: 'string', nullable: true },
                    insuredCity: { type: 'string', nullable: true },
                    insuredPostalCode: { type: 'string', nullable: true },
                    insuredStateAbbrev: { type: 'string', nullable: true },
                    insuredPhone: { type: 'string', nullable: true },
                    insuredEmail: { type: 'string', nullable: true },
                    insuredMaritalStatus: { type: 'string', nullable: true },
                    insuredPrimLanguage: { type: 'string', nullable: true },
                    insuredJobTitle: { type: 'string', nullable: true },
                    insuredJobStatus: { type: 'string', nullable: true },
                    insuredEmployerName: { type: 'string', nullable: true },
                    insuredEmployerStatus: { type: 'string', nullable: true },
                    insuredGender: { type: 'string', nullable: true },
                    insuredMaleGender: { type: 'boolean', nullable: true },
                    patRelToInsuredId: { type: 'string', nullable: true },
                    patRelToInsuredText: { type: 'string', nullable: true },
                    groupNumber: { type: 'string', nullable: true },
                    groupName: { type: 'string', nullable: true },
                    planEffectiveDate: { type: 'string', nullable: true },
                    planExpirationDate: { type: 'string', nullable: true },
                    authorizationCode: { type: 'string', nullable: true },
                    authorizationDate: { type: 'string', nullable: true },
                    planType: { type: 'string', nullable: true },
                    companyPlanCode: { type: 'string', nullable: true },
                    policyNumber: { type: 'string', nullable: true },
                    policyLimitAmount: { type: 'string', nullable: true },
                    policyLimitDays: { type: 'string', nullable: true },
                    verificationDateTime: { type: 'string', nullable: true },
                    verificationBy: { type: 'string', nullable: true },
                    verificationStatus: { type: 'string', nullable: true },
                    assignmentOfBenefits: { type: 'string', nullable: true },
                    coordOfBenefits: { type: 'string', nullable: true },
                    coordOfBenefitsPriority: { type: 'string', nullable: true },
                    noticeOfAdmissionFlag: { type: 'string', nullable: true },
                    noticeOfAdmissionDate: { type: 'string', nullable: true },
                    releaseInformationCode: { type: 'string', nullable: true },
                    preAdmissionCert: { type: 'string', nullable: true },
                    typeOfAgreementCode: { type: 'string', nullable: true },
                    billingStatus: { type: 'string', nullable: true },
                    lifetimeReserveDays: { type: 'string', nullable: true },
                    delayBeforeLRDay: { type: 'string', nullable: true },
                    roomRateSemiPrivate: { type: 'string', nullable: true },
                    roomRatePrivate: { type: 'string', nullable: true },
                },
            },
        },
        enctrDiagnosisDoc: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: { type: 'string' },
                    codingMethod: { type: 'string', nullable: true },
                    diagCode: { type: 'string', nullable: true },
                    diagDesc: { type: 'string', nullable: true },
                    diagDate: { type: 'string', nullable: true },
                    diagTime: { type: 'string', nullable: true },
                    diagType: { type: 'string', nullable: true },
                },
            },
        },
        enctrRelationsDoc: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: { type: 'string' },
                    lastName: { type: 'string', nullable: true },
                    firstName: { type: 'string', nullable: true },
                    middleName: { type: 'string', nullable: true },
                    address1: { type: 'string', nullable: true },
                    address2: { type: 'string', nullable: true },
                    city: { type: 'string', nullable: true },
                    stateAbbrev: { type: 'string', nullable: true },
                    postalCode: { type: 'string', nullable: true },
                    countryCode: { type: 'string', nullable: true },
                    homePhone: { type: 'string', nullable: true },
                    businessPhone: { type: 'string', nullable: true },
                    maritalStatus: { type: 'string', nullable: true },
                    gender: { type: 'string', nullable: true },
                    dob: { type: 'string', nullable: true },
                    primaryLanguage: { type: 'string', nullable: true },
                    jobTitle: { type: 'string', nullable: true },
                    jobStatus: { type: 'string', nullable: true },
                    relToPatient: { type: 'string', nullable: true, description: 'Relationship to the patient' },
                    ssn: { type: 'string', nullable: true },
                },
            },
        },
        enctrGuarantorDoc: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: { type: 'string' },
                    lastName: { type: 'string', nullable: true },
                    firstName: { type: 'string', nullable: true },
                    middleName: { type: 'string', nullable: true },
                    addressLine1: { type: 'string', nullable: true },
                    addressLine2: { type: 'string', nullable: true },
                    city: { type: 'string', nullable: true },
                    stateAbbrev: { type: 'string', nullable: true },
                    postalCode: { type: 'string', nullable: true },
                    countryCode: { type: 'string', nullable: true },
                    ssn: { type: 'string', nullable: true },
                    dob: { type: 'string', nullable: true },
                    gender: { type: 'string', nullable: true },
                    homePhone: { type: 'string', nullable: true },
                    businessPhone: { type: 'string', nullable: true },
                    relToPatient: { type: 'string', nullable: true, description: 'Relationship to the patient' },
                    employmentStatus: { type: 'string', nullable: true },
                    type: { type: 'string', nullable: true },
                    maritalStatus: { type: 'string', nullable: true },
                    occupation: { type: 'string', nullable: true },
                    primaryLanguage: { type: 'string', nullable: true },
                    employerLastName: { type: 'string', nullable: true },
                    employerFirstName: { type: 'string', nullable: true },
                    employerMiddleName: { type: 'string', nullable: true },
                    employerAddress1: { type: 'string', nullable: true },
                    employerAddress2: { type: 'string', nullable: true },
                    employerPostalCode: { type: 'string', nullable: true },
                    employerCity: { type: 'string', nullable: true },
                    employerStateAbbrev: { type: 'string', nullable: true },
                    employerCountryCode: { type: 'string', nullable: true },
                    employerPhone: { type: 'string', nullable: true },
                },
            },
        },
    },
};
